export default {
  activeRequests: 0,
  session: {},
  previousRoute: {},
  whiteLabel: null,
  currentUser: {},
  userReadAt: null
}
